import React, { useState, useEffect } from 'react';
import { hooks } from '../hooks';
import { svg } from '../assets/svg';
import Switch from 'react-switch'
import { useNavigate } from 'react-router-dom'
import food from '../assets/images/food.png'
import Config from '../configs/config.json';
import Popover from 'react-popover'
import { FaBell } from 'react-icons/fa'

type Props = {
  showBurger?: boolean;
  showButton?: boolean;
  showSwitch?: boolean;
  headerStyle?: React.CSSProperties;
  setIsGreenToggled?: (value: boolean) => void;
  setIsRedToggled?: (value: boolean) => void;
};

export const Header: React.FC<Props> = ({
  showBurger,
  showSwitch,
  showButton,
  headerStyle,
  setIsGreenToggled,
  setIsRedToggled
}) => {
  const navigate = hooks.useNavigate();

  const [isGreenToggleOn, setIsGreenToggleOn] = useState(false)
  const [isRedToggleOn, setIsRedToggleOn] = useState(false)

  const [isPopoverOpen, setIsPopoverOpen] = useState(false)

  const handleTogglePopover = () => {
    setIsPopoverOpen(!isPopoverOpen)
  }

  const handleOrders = () => {
    setIsPopoverOpen(false)
    navigate('/order-details')

    // const orderId = localStorage.getItem('orderId')
    // setIsPopoverOpen(false)
    // navigate(`/order-successful/${orderId}`)
  }

  // const [restaurant, setRestaurant] = useState(null)

  const restaurant = localStorage.getItem('restaurant');
  const res = restaurant ? JSON.parse(restaurant) : null;

  const tableData = localStorage.getItem('table');
  const table = tableData ? JSON.parse(tableData) : null;

  const logoUrl = res && res.logo
    ? `${Config.MEDIA_URL}${res.logo}?alt=media`
    : food;

  const handleGreenToggleChange = (checked: boolean) => {
    setIsGreenToggleOn(checked);

    if (setIsGreenToggled) {
      setIsGreenToggled(checked);
    }
  };

  const handleRedToggleChange = (checked: boolean) => {
    setIsRedToggleOn(checked);

    if (setIsRedToggled) {
      setIsRedToggled(checked);
    }
  };

  const handleBack = () => {
    const token = localStorage.getItem('token');
    if (token) {
      nav(`/${token}`)
    }
  }

  const nav = useNavigate()

  const [themeColor, setThemeColor] = useState('#fff');

  hooks.useThemeColor(themeColor);

  const renderButton = (): JSX.Element | null => {
    if (!showButton) return null;

    const smallScreen = window.innerWidth === 320 && window.innerHeight === 568;

    return (
      <div className='container' style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        width: '100%',
        padding: '10px 15px',
      }}>

        <div onClick={() => handleBack()}
          style={{ cursor: 'pointer' }} >

          <img
            src={logoUrl}
            alt="Restaurant Logo"
            style={{
              width: smallScreen ? "80px" : '100px',
              height: 'auto',
              marginTop: 12,
            }}
          />
          <h5
            style={{
              textAlign: 'left',
              marginBottom: 12,
              textTransform: 'capitalize',
              fontWeight: 500,
              fontSize: smallScreen ? 12 : 12,
              marginTop: 3

            }}
          >
            {table ? `${table.type} - ${table.number}` : ""}
          </h5>
        </div>

        {showSwitch && <div style={{
          display: 'flex', alignItems: 'center', justifyContent: "center", marginLeft: 5, gap: smallScreen ? 5 : 10,
        }}>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: "center", gap: 5 }}>
            <div
              style={{
                border: '1px solid #d3d3d3',
                borderRadius: '20px',
                padding: '5px 10px',
                display: 'inline-block',

              }}
            >
              <Switch
                checked={isGreenToggleOn}
                // onChange={setIsGreenToggleOn}
                onChange={handleGreenToggleChange}
                onColor='#029711'
                offColor='#e0e0e0'
                handleDiameter={10}
                uncheckedIcon={false}
                checkedIcon={false}
                height={7}
                width={25}
                className="green-switch"
              />
            </div>
          </div>
          <div style={{ display: 'flex', alignItems: 'center', gap: 5 }}>
            <div
              style={{
                border: '1px solid #d3d3d3',
                borderRadius: '20px',
                padding: '5px 10px',
                display: 'inline-block',
              }}
            >
              <Switch
                checked={isRedToggleOn}
                // onChange={setIsRedToggleOn}
                onChange={handleRedToggleChange}
                onClick={() => handleRedToggleChange(!isRedToggleOn)}
                onColor='#ff0000'
                offColor='#e0e0e0'
                handleDiameter={10}
                uncheckedIcon={false}
                checkedIcon={false}
                height={7}
                width={25}
                className='red-switch'

              />
            </div>
          </div>
        </div >
        }
        {showBurger && (
          <Popover
            isOpen={isPopoverOpen}
            onOuterAction={() => setIsPopoverOpen(false)}
            place='left'
            body={
              <div style={{ padding: '10px 20px', background: '#fff', boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.1), 4px 0px 10px rgba(0, 0, 0, 0.1), -4px 0px 10px rgba(0, 0, 0, 0.1), 0px -4px 10px rgba(0, 0, 0, 0.1)', borderRadius: '8px' }}>
                <button onClick={handleOrders} style={{ border: 'none', background: 'none', cursor: 'pointer', fontSize: '12px', fontFamily: "Poppins" }}>View Order</button>
              </div>
            }
          >
            <button
              style={{
                height: '100%',
                width: 'auto',
                // padding: '0 20px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                cursor: 'pointer',
                textAlign: 'right',
              }}
              // onClick={() => handleBack()}
              onClick={handleTogglePopover}
            >
              <svg.BurgerSvg />
            </button>
          </Popover>
        )}

      </div >
    );
  };


  return (
    <>
      <header
        style={{
          position: 'relative',
          height: 70,
          backgroundColor: '#fff',
          ...headerStyle,
          paddingBottom: 10,
        }}
        className='row-center-space-between'
      >
        {renderButton()}
      </header>

    </>
  );
};
